/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _BioExamMonitoringEditionForm;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable parog-web/migrate-non-patch-forms */
import { service } from "@ember/service";
import JournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import BioExamExpectedDosageChangedJournalEvent from "core/models/bio-exam-expected-dosage-changed-journal-event";
import BioExamOrder from "core/models/bio-exam-order";
import { validateNumber } from "ember-changeset-validations/validators";
import { IntlService } from "ember-intl";

/**
 * @typedef {import("core/models/bio-exam-order").default} BioExamOrder
 */
let BioExamMonitoringEditionForm = (_class = (_BioExamMonitoringEditionForm = class BioExamMonitoringEditionForm extends JournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.lastJournalEvent);
  }
  get validations() {
    return this._generateValidation();
  }
  get bioExams() {
    return [
    // Tacrolimus
    "77348-1",
    // Cyclosporine
    "53828-0",
    // Sirolimus
    "72676-0",
    // Everolimus
    "72671-1"].map(code => this.store.peekRecord("bio-exam-order", code));
  }
  retrieveModel() {
    const model = {};

    // Inject values from the dosages directly into the model
    const expectedDosageJe = this.retrieveJournalEvent();
    if (expectedDosageJe) {
      expectedDosageJe.expectedDosages.forEach(dosage => {
        model[this._computeMinKey(dosage.code)] = dosage.min;
        model[this._computeMaxKey(dosage.code)] = dosage.max;
      });
    }
    return model;
  }

  /**
   * @typedef {Object} ExpectedDosage
   * @property {number} min
   * @property {number} max
   * @property {string} code
   */
  computePayload() {
    // Retrieve the dosages from the model
    const expectedDosages = this.bioExams.map(exam => {
      const min = this.model[this._computeMinKey(`LOINC-${exam.loinc}`)] || undefined;
      const max = this.model[this._computeMaxKey(`LOINC-${exam.loinc}`)] || undefined;
      return {
        code: `LOINC-${exam.loinc}`,
        min,
        max
      };
    }).filter(dosage => dosage.min !== undefined || dosage.max !== undefined);
    return {
      patient: this.patient,
      occurredAt: new Date(),
      expectedDosages
    };
  }
  _computeMinKey(code) {
    return `min-${code}`;
  }
  _computeMaxKey(code) {
    return `max-${code}`;
  }
  _generateValidation() {
    const validations = this.journalEventClass.validations(this.intl);
    this.bioExams.forEach(exam => {
      if (exam) {
        validations[this._computeMinKey(`LOINC-${exam.loinc}`)] = validateNumber({
          description: "Le dosage minimum",
          allowBlank: true
        });
        validations[this._computeMaxKey(`LOINC-${exam.loinc}`)] = validateNumber({
          description: "Le dosage maximum",
          allowBlank: true
        });
      }
    });
    return validations;
  }
}, _defineProperty(_BioExamMonitoringEditionForm, "forcDisplayName", "Dosages immunosuppresseurs cibles (T0)"), _defineProperty(_BioExamMonitoringEditionForm, "fullComponentId", "bio-exam-monitoring/edition-form"), _defineProperty(_BioExamMonitoringEditionForm, "journalEventClass", BioExamExpectedDosageChangedJournalEvent), _BioExamMonitoringEditionForm), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BioExamMonitoringEditionForm as default };